export const PositionTypes = {
    TopPushSiteDown: 0,
    TopLayoverSite: 1,
    BottomLayoverSite: 2
};